/**
 * WeatherCondition enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file WeatherCondition.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum WeatherCondition {
  CLEAR = 0,
  RAIN = 1,
  SNOW = 2,
  LIGHTNING = 3
};